<template>
    <div class="d-flex align-items-stretch">
        <div>
            <div
                v-bind:class="textOperatorClassName"
                class="align-self-center">
                {{ textDisplay }}
            </div>
        </div>
        <parens left />
        <div class="d-flex align-items-center">
            {{ display }}
        </div>
        <parens />
    </div>
</template>
<script>
    import displayReference from "./_displayReferenceMixin.js";
    import base from "./_baseExpression.vue";
    import { EXPRESSION_TYPES } from "Formula/expressionTypes";
    import { EXPRESSION_PROPERTY_NAMES } from "Formula/metadata.js";
    import { ENERGY_STORAGE_SUBSYSTEM_TYPE } from "Forms/Components/ProjectForm/ProjectElements/energyStorageSystemElementController";

    export default {
        extends: base,
        mixins: [displayReference],
        computed: {
            textDisplay() {
                let textName = "";
                switch (this.expression.Type) {
                    case EXPRESSION_TYPES.ExistsSameMultiInstanceValue:
                        textName = "ALL MATCH";
                        break;
                    case EXPRESSION_TYPES.CoalesceMultiInstanceValue:
                        textName = "VALUE OF ALL MATCH";
                        break;
                    case EXPRESSION_TYPES.SumMultiInstanceValue:
                        textName = "SUM ALL";
                        break;
                    case EXPRESSION_TYPES.CountTrueMultiInstanceValue:
                        textName = "COUNT TRUE";
                        break;
                    case EXPRESSION_TYPES.CountMatchingTextMultiInstanceValue:
                        textName = "COUNT MATCHING TEXT";
                        break;
                }
                const selectedESSSubsystemType =
                    this.expression.PropertyDictionary[EXPRESSION_PROPERTY_NAMES.ESSSubsystemType];
                if (selectedESSSubsystemType) {
                    switch (Number(selectedESSSubsystemType)) {
                        case ENERGY_STORAGE_SUBSYSTEM_TYPE.IntegratedEnergyStorageSystem:
                            textName += " for Integrated Energy Storage System";
                            break;
                        case ENERGY_STORAGE_SUBSYSTEM_TYPE.InverterAndBattery:
                            textName += " for Inverter And Battery";
                    }
                }
                return textName;
            },
            display() {
                return this.getReferenceDisplay();
            }
        }
    };
</script>
